import { useEffect, useState } from 'react';
import {
  MapContainer,
  TileLayer,
  Marker,
  useMap,
  useMapEvent,
  Circle,
  Tooltip,
} from 'react-leaflet';
import markerIconPng from 'leaflet/dist/images/marker-icon.png';
import { Icon } from 'leaflet';
import { defaultValues, mapElementsLimit } from '../config';
import { getQuakeCoordinates } from '../utilities';
import PopupLayer from './PopupLayer';

const API_KEY = '785f2ef6-32e3-4cd2-8ecb-c3e3b0a29066';
const mapTileUrl = `https://tiles.stadiamaps.com/tiles/outdoors/{z}/{x}/{y}{r}.png?api_key=${API_KEY}`;
// const mapTileUrl = 'https://{s}.tile.openstreetmap.org.fr/hot/{z}/{x}/{y}.png';
const redOptions = { color: 'red', stroke: 0 };

function MapPlaceholder() {
  return (
    <p>
      Map of the Philippines.{' '}
      <noscript>You need to enable JavaScript to see this map.</noscript>
    </p>
  );
}

function Markers({ quakes, updateBounds }) {
  const map = useMap();

  const [bounds, setBounds] = useState(map.getBounds());
  const [isDeetsShowing, setIsDeetsShowing] = useState(false);

  useMapEvent('moveend', () => {
    updateBounds(map.getBounds());
    setBounds(map.getBounds());
  });

  function getQuakeRadius({
    properties: { mag, sig },
    geometry: { coordinates },
  }) {
    // return Math.exp(mag / 1.01 - 0.13) * 1000;
    return sig * 150; // sig is 0 to 1000
  }

  function getIcon() {
    return new Icon({
      iconUrl: markerIconPng,
      iconSize: [25, 41],
      iconAnchor: [12, 41],
    });
  }

  function handleClick(e) {
    setIsDeetsShowing(!isDeetsShowing);
  }

  const visibleQuakes = quakes.filter(({ geometry: { coordinates } }) => {
    const latlng = {
      lat: coordinates[1],
      lng: coordinates[0],
    };
    return bounds.contains(latlng);
  });

  return (
    <>
      {visibleQuakes?.map((quake) => (
        <Circle
          center={getQuakeCoordinates(quake)}
          pathOptions={redOptions}
          radius={getQuakeRadius(quake)}
          key={quake.id}
          onClick={handleClick}
        >
          <PopupLayer quake={quake} />
          <Tooltip>
            {quake.properties.mag}M &nbsp;
            {quake.properties.place[0].toUpperCase() +
              quake.properties.place.slice(1)}
          </Tooltip>
        </Circle>
      ))}

      {map._zoom > 7 &&
        visibleQuakes.length <= mapElementsLimit &&
        visibleQuakes?.map((quake) => (
          <Marker
            position={getQuakeCoordinates(quake)}
            icon={getIcon()}
            key={quake.id}
          >
            <PopupLayer quake={quake} />
          </Marker>
        ))}
    </>
  );
}

function ChangeCenter({ center, updateBounds, setPage }) {
  const map = useMap();

  useEffect(
    function () {
      updateBounds(map.getBounds());
      setPage(1);

      map.setView(center); // updates map center
    },
    [center, map, setPage, updateBounds]
  );
  return null;
}

export default function Map({ quakes, mapCenter, updateBounds, setPage }) {
  return (
    <div className="map">
      <MapContainer
        {...defaultValues.mapOptions}
        center={mapCenter}
        placeholder={<MapPlaceholder />}
      >
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          url={mapTileUrl}
        />

        <Markers
          quakes={quakes}
          center={mapCenter}
          updateBounds={updateBounds}
        />
        <ChangeCenter
          center={mapCenter}
          updateBounds={updateBounds}
          setPage={setPage}
        />
      </MapContainer>
    </div>
  );
}
